module.exports = __webpack_public_path__ + "static/img/erweima.6aa632d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/erweima.jpg
// module id = qbju
// module chunks = 1